module.exports = __webpack_public_path__ + "static/img/user.428c70b5.png";